// PRODA Wholesale (/wholesale): the hero's shelf of cans turns on hover like the homepage lineup (js/can-spin.js), and
// the lineup's case cards come from the catalog, each with its case UPC.
import { $, $$, initChrome } from 'v2/ui.js';
import { ASSET_V, FLAVORS, WHOLESALE } from 'v2/catalog.js';
import { canSpin } from 'v2/can-spin.js';
import { asset } from 'v2/asset.js';

// Cards first, so the reveal in initChrome sees them.
$('[data-trade-lineup]').innerHTML = FLAVORS.filter((f) => WHOLESALE.items[f.id]).map((f, i) => `
  <li class="lineup-case f-${f.id}" data-reveal style="--d:${(i % 4) * 70}ms">
    <img src="${asset(`img/case-${f.id}-480.webp?v=${ASSET_V}`)}" srcset="${asset(`img/case-${f.id}-480.webp?v=${ASSET_V}`)} 480w, ${asset(`img/case-${f.id}-1400.webp?v=${ASSET_V}`)} 1400w" sizes="(max-width: 999px) 46vw, 22vw" alt="A 12-can case of PRODA ${f.name}" width="480" height="480" loading="lazy" decoding="async">
    <h3>${f.name}</h3>
    <p>12 x 12 fl oz · UPC ${WHOLESALE.items[f.id].upc}</p>
  </li>`).join('');

initChrome();

$$('[data-trade-shelf] .shelf__link').forEach((a) => canSpin($('.shelf__can', a), a.getAttribute('href').slice(1), { zone: a }));

// The header marks the section on screen (the page's own anchors), like the homepage nav.
const links = $$('.chrome__nav a[href^="/wholesale#"]');
const sections = links.map((a) => document.getElementById(a.getAttribute('href').split('#')[1]));
let ticking = false;
function spy() {
  ticking = false;
  const line = innerHeight * 0.4;
  const current = sections.find((s) => s && s.getBoundingClientRect().top <= line && s.getBoundingClientRect().bottom > line);
  links.forEach((a, i) => a.classList.toggle('is-active', sections[i] === current));
}
addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(spy); } }, { passive: true });
spy();
